









import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SubNavigationList extends Vue {

    get componentClasses(): object {
        return {
            'new-navigation-submenu-list': true,
        }
    }
}

